import React, { useState } from 'react';
import { toast } from 'sonner';
import { InvoiceToggle } from './InvoiceToggle';

const fromOrder = (o) => ({
  requires_invoice: !!o.requires_invoice,
  rfc: o.invoice_rfc || '',
  razon_social: o.invoice_razon_social || '',
  apply_isr: !!o.invoice_apply_isr,
});

export const ChargeInvoiceSection = ({ order, backendUrl, onUpdated }) => {
  const [value, setValue] = useState(() => fromOrder(order));
  const gross = order.requires_invoice ? order.invoice_gross : order.total;

  const commit = async (v) => {
    try {
      const res = await fetch(`${backendUrl}/api/orders/${order.id}/invoice`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(v),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Error');
      setValue((prev) => ({ ...prev, rfc: prev.rfc || data.invoice_rfc || '' }));
      onUpdated(data);
    } catch (e) {
      toast.error(`No se pudo actualizar la factura: ${e.message}`);
    }
  };

  return (
    <div className="mb-4">
      <InvoiceToggle value={value} gross={gross} onChange={setValue} onCommit={commit} idPrefix="charge" />
    </div>
  );
};
